import { Menu } from "antd";
import { Logo } from "../Logo";
import { GeneralStore } from "../../stores";
import { useNavigate, useLocation } from "react-router-dom";
import { SidebarItems } from "../../layouts/constants/SidebarData";

export const MainSidebarItems = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const sidebarItems = SidebarItems();
  const {
    sidebarCollapsed,
    mobileSidebarOpen,
    setContentPadding,
    setMobileSidebarOpen,
  } = GeneralStore();

  return (
    <div>
      <div
        className={`spor-sidebar-brand flex items-center justify-center sticky top-0 inset-x-0 z-40 ${
          sidebarCollapsed ? "px-2 py-3 min-h-[64px]" : "px-4 py-4 min-h-[88px]"
        }`}
      >
        <Logo
          size={sidebarCollapsed ? "sm" : "md"}
          className={
            sidebarCollapsed
              ? "h-10 w-10"
              : "h-[72px] w-full max-w-[200px]"
          }
        />
      </div>
      <Menu
        mode="inline"
        className="spor-sidebar-menu"
        selectedKeys={[pathname]}
        onSelect={(e) => {
          navigate(e.key);
          if (mobileSidebarOpen) {
            setMobileSidebarOpen(false);
          }
          setContentPadding(true);
        }}
        items={sidebarItems.filter((item) => !item.disabled)}
        theme="light"
      />
    </div>
  );
};
